import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useVehicleContext } from "./ModelContext.tsx";

export function DeleteVehicleDialog() {
  const vehicle = useVehicleContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Delete vehicle?"
      description={`Are you sure you want to delete ${vehicle.name}? You cannot undo this.`}
      submitLabel="Delete"
      theme="red"
      onSubmit={async () => {
        const nextGang = vehicle.gang.removeVehicle(vehicle);
        return await database.gangs.updateOne(nextGang.data);
      }}
      onSuccess={(gangId) => {
        toast("Vehicle deleted");
        navigate(`~/gangs/g/${gangId}`);
      }}
    />
  );
}
